/** The app path to return to after sign-in; anything that could leave the origin gives "/". */
export function safeReturnPath(value: unknown): string {
  if (typeof value !== "string" || !value.startsWith("/")) return "/";
  // "//host" and "/\host" are protocol-relative URLs to another origin.
  if (value.startsWith("//") || value.startsWith("/\\")) return "/";
  return value;
}
